import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import {
  DraftReturn,
  Order as DraftReturnOrder,
} from "@redotech/redo-model/draft-return/draft-return";
import { getReturnOrders } from "@redotech/redo-model/draft-return/util";
import {
  getResource,
  Resource,
} from "@redotech/redo-model/localization/resource";
import { THIRD_PARTY_SOURCE } from "@redotech/redo-model/third-party";
import { getDateString } from "@redotech/redo-web/date-utils";
import { memo } from "react";
import * as returnStyles from "../return.module.css";

export const ReviewPageHeader = memo(function ReviewPageHeader({
  headerText,
  displayHeaderOnly,
  draftReturn,
  settings,
}: {
  headerText: string;
  displayHeaderOnly: boolean;
  draftReturn: DraftReturn;
  settings?: ReturnAppSettings;
}) {
  const resource = getResource({ overrides: settings?.resourceOverride });
  const getOrderDate = (order: DraftReturnOrder) => {
    const dateCreated = new Date(order.orderDate);
    return getDateString(dateCreated);
  };
  const returnOrders = getReturnOrders(draftReturn);

  const OrderNumber = ({
    orderName,
    salesChannel,
    orderDate,
    resource,
  }: {
    orderName: string;
    salesChannel: string;
    orderDate: string;
    resource: Resource;
  }) => {
    const orderlessName = resource.ORDERLESS_DISPLAY_NAME;
    const orderDisplayName =
      salesChannel === THIRD_PARTY_SOURCE ? orderlessName : orderName;

    if (!displayHeaderOnly) {
      return (
        <div className={returnStyles.header}>
          <div className={returnStyles.flex}>
            <div className={returnStyles.grayTextOnGrayBg}>Order:&nbsp;</div>
            <div className={returnStyles.orderNumber}>{orderDisplayName}</div>
          </div>
          <div className={returnStyles.grayTextOnGrayBg}>{orderDate}</div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={returnStyles.pagePadding}>
      <div>
        <div className={returnStyles.mainHeader}>{headerText}</div>
      </div>
      {Object.values(returnOrders).map((order) => (
        <div className={returnStyles.orderAndDate} key={order.name}>
          <OrderNumber
            orderDate={getOrderDate(order)}
            orderName={order.name}
            resource={resource}
            salesChannel={order.salesChannel}
          />
        </div>
      ))}
    </div>
  );
});
